import * as React from 'react';
import Container from '../../../containers/user/students/editStudentContainer';

export default function () {
  return (
    <Container />
  );
}
